'use client';

import { IBlogConfig } from '@/api/types/blog';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { useMemo } from 'react';

interface AuthorNavListProps {
  navList: IBlogConfig[];
  isWeb?: boolean;
}

interface NavItem {
  child_id?: number;
  name?: string;
  level?: number;
  another_name?: string;
}

export default function AuthorNavList({ navList, isWeb = false }: AuthorNavListProps) {
  const router = useRouter();

  const clickableNavList = useMemo(() => {
    const list: NavItem[] = [];

    navList.forEach((item) => {
      if (Array.isArray(item.content?.child) && item.content.child.length) {
        item.content.child.forEach((child) => {
          list.push(child);
        });
      }
    });

    return list;
  }, [navList]);

  const getHref = (item: NavItem) => {
    if (item.level !== 1) {
      return `/blog/${item.another_name}`;
    } else if (item.child_id === 1 || item.child_id === 2) {
      // shop_zeelool or all_blogs
      return '/blog';
    }
    return '';
  };

  const handleClick = (item: NavItem) => {
    if (item.level === 1) {
      sessionStorage.setItem('zl-blog-type-change', String(item.child_id || ''));
    }
    const href = getHref(item);
    if (href) {
      router.push(href);
    }
  };

  return (
    <div
      className={`flex flex-wrap items-center ${isWeb ? 'mt-[72px] px-48 pb-32 justify-center' : 'mt-36 mx-auto pb-40'}`}
    >
      {clickableNavList.map(
        (item) =>
          item.name && (
            <Link
              prefetch={false}
              key={item.child_id}
              href={getHref(item)}
              onClick={(e) => {
                e.preventDefault();
                handleClick(item);
              }}
              className={`
                box-border border border-[#808080] bg-white
                ${
                  isWeb
                    ? 'h-32 mx-8 mb-8 px-16 text-14 leading-[32px] rounded-16 hover:bg-[rgba(128,128,128,0.05)]'
                    : 'h-28 mr-12 mb-12 px-14 rounded-18 text-12 leading-[28px]'
                }`}
              aria-label={item.name}
            >
              {item.name}
            </Link>
          ),
      )}
    </div>
  );
}
